var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8151_48958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9993 6.66602H8.33268C7.41221 6.66602 6.66602 7.41221 6.66602 8.33268V14.9993C6.66602 15.9198 7.41221 16.666 8.33268 16.666H14.9993C15.9198 16.666 16.666 15.9198 16.666 14.9993V8.33268C16.666 7.41221 15.9198 6.66602 14.9993 6.66602Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 6.66732V5.00065C13.334 4.55862 13.1584 4.1347 12.8458 3.82214C12.5333 3.50958 12.1093 3.33398 11.6673 3.33398H5.00065C4.55862 3.33398 4.1347 3.50958 3.82214 3.82214C3.50958 4.1347 3.33398 4.55862 3.33398 5.00065V11.6673C3.33398 12.1093 3.50958 12.5333 3.82214 12.8458C4.1347 13.1584 4.55862 13.334 5.00065 13.334H6.66732",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8151_48958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyEmailIcon);
export default __webpack_public_path__ + "static/media/copy-email-icon.6a1890448818144e083037c88850e6b9.svg";
export { ForwardRef as ReactComponent };